import { Ogp } from "shared/features/utils";
import { NextPageWithLayout } from "shared/types";

import { StandardLayout } from "~/components/layouts";
import { AuthedRoute } from "~/features/auth";
import { FriendCoupon } from "~/features/users/pages/FriendCoupon";

const Page: NextPageWithLayout = () => {
  return (
    <AuthedRoute>
      <Ogp title="お友達紹介クーポン" />
      <FriendCoupon />
    </AuthedRoute>
  );
};

Page.getLayout = (page) => <StandardLayout>{page}</StandardLayout>;

export default Page;
